import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { defaultSingleObjectState } from "utils/constants";
import { isAdminUser } from "utils/adminAuth";
import appReducer from "./reducers";
import rootSaga from "./sagas";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?? compose;

const sagaMiddleWare = createSagaMiddleware();

const userObj = JSON.parse(localStorage.getItem("userInfo") ?? "{}");
const foundUser = Object.keys(userObj).length !== 0 && isAdminUser(userObj);
if (Object.keys(userObj).length !== 0 && !foundUser) {
  localStorage.removeItem("userInfo");
}
const userState = {
  ...defaultSingleObjectState,
  data: userObj.data,
  success: !!foundUser,
};

const userInfoFromStorage = foundUser ? userState : defaultSingleObjectState;

const initialState = {
  auth: {
    user: userInfoFromStorage,
  },
};

export default function configureStore() {
  const store = createStore(
    appReducer,
    initialState,
    composeEnhancers(applyMiddleware(sagaMiddleWare)),
  );

  sagaMiddleWare.run(rootSaga);
  return store;
}
